import {useCallback} from 'react';
import {useAppDispatch} from 'store/hooks';
import type {WorkItemsState} from '../types';
import {setWorkItems} from '../workItemsSlice';

export const useSetWorkItems = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (workItems: WorkItemsState) => {
      dispatch(setWorkItems(workItems));
    },
    [dispatch],
  );
};
